import { useI18n } from '@affine/i18n';
import type { FC } from 'react';

import { EnumSelect } from '../controls/enum-select';
import { ROW_DETAIL_OPTIONS } from './option-constants';
import type { SectionProps } from './types';

export const RowDetailSection: FC<SectionProps> = ({ row, setField }) => {
  const t = useI18n();
  const dashboardMode = row.layoutType === 'dashboard';
  return (
    <EnumSelect
      label={t['com.streamlain.customApps.viewConfig.rowDetail.label']()}
      description={
        dashboardMode
          ? t['com.streamlain.customApps.viewConfig.rowDetail.descDashboard']()
          : t['com.streamlain.customApps.viewConfig.rowDetail.descDefault']()
      }
      data-sl-field="rowDetailMode"
      value={row.rowDetailMode}
      options={ROW_DETAIL_OPTIONS}
      onChange={v => setField('rowDetailMode', v)}
      disabled={dashboardMode}
    />
  );
};
